import { useCallback, useState, useEffect } from "react";
import { fetchTaskByPagination } from "../services/TaskService";

export const useTaskList = (taskStatus, company, userGroup, userName) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)



  const fetchData = useCallback(async (page) => {
    if(!page) {
      page = 1;
    }

    if (!company) {
      setError('Company information missing');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        filter: {
          company_cd: company,
          type: "task_service",
          response: {
            user_group: userGroup,
            assignment_status: taskStatus.toUpperCase()
          }
        },
        sort: {}
      };

      const tasksData = await fetchTaskByPagination(
        (page - 1) * 10,
        10,
        payload,
      );
      console.log("Task Data",tasksData)
      setData(tasksData || []);
      setError(null);
    } catch (err) {
      if (err.name !== 'AbortError') {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  }, [company, userGroup, taskStatus]);

  useEffect(() => {
  }, []);

  return { data, 
           loading, 
           error, 
           currentPage, 
           setCurrentPage, 
           totalPages, 
           setTotalPages, 
           totalCount, 
           setTotalCount, 
           fetchData };
};